import React, { useState } from "react";
import "./ShareCard.css";
import bgImage from "../assets/imges/image.png";
import SharePopup from "./SharePopup.jsx";

const ShareCard = ({
    title = "આ એપ્લિકેશન શેર કરો",
    subtitle = "તમારા મિત્રો સુધી આ એપ્લિકેશન પહોંચાડો અને તેમનો ઉપયોગ સરળ બનાવો",
}) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <div
                className="share-card"
                style={{ backgroundImage: `url(${bgImage})` }}
                onClick={() => setOpen(true)}
            >
                <div className="share-left-icon">
                    <span className="material-symbols-outlined share-icon">
                        diversity_3
                    </span>
                </div>

                <div className="share-texts">
                    <h3>{title}</h3>
                    <p>{subtitle}</p>
                </div>

                <span className="material-symbols-outlined right-icon">
                    ads_click
                </span>
            </div>

            {/* Popup */}
            {open && <SharePopup onClose={() => setOpen(false)} />}
        </>
    );
};

export default ShareCard;
